import { render, staticRenderFns } from "./project-task-panel.vue?vue&type=template&id=3b1116e1&scoped=true"
import script from "./project-task-panel.vue?vue&type=script&lang=js"
export * from "./project-task-panel.vue?vue&type=script&lang=js"
import style0 from "./project-task-panel.vue?vue&type=style&index=0&id=3b1116e1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../mnt/host/d/wwwroot/deepcityAI/user-client-pc/user-client-common-pc/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1116e1",
  null
  
)

export default component.exports